import { Component, Inject } from '@angular/core';
import { LoginService } from '../../../core/services/login.service';

@Component({
  selector: 'ng-kits-header',
  template: require('./header.component.html').default,
  standalone: false,
})
export class NgHeaderComponent {
  isCollapsed = true;
  constructor(@Inject(LoginService) private login: LoginService) {}

  isLoggedIn() {
    return this.login.getLoginState().isLoggedIn;
  }
}
